.tag {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 0.3rem;
  padding: 0.1rem 0.4rem;
  border: 1px solid;
}
